module.exports = __webpack_public_path__ + "img/QPKH.dffdb407.png";